import { Helmet } from 'react-helmet';

const SEO = ({
  title = "FIGO Digital Services - Custom Software Development & Digital Transformation",
  description = "Leading digital transformation agency in Nigeria. We build custom software, AI automation, mobile apps, and provide complete digital solutions for businesses in Abuja, Lagos & globally.",
  keywords = "software development Nigeria, digital transformation, AI automation, custom software, mobile app development",
  image = "https://figodigitalservices.com/figo-logo9.png",
  url = "https://figodigitalservices.com",
  type = "website"
}) => {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />

      {/* Canonical */}
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

export default SEO;
